export enum FormTracking {
  CATEGORY = 'realtor_contact',
  ACTION = 'mail',
  LABEL = 'form',
}
